import { CpuChipIcon, Squares2X2Icon } from '@heroicons/react/24/outline'
import type { ComponentType, SVGProps } from 'react'

import { Text } from '../../../common/designs'
import { type ProcessAnalysisConfig, ProcessDataOriginEnum } from '../types'
import ProcessOriginBadge from './ProcessOriginBadge'

type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>

function leadIcon(origin: ProcessDataOriginEnum): SvgIcon {
  if (origin === ProcessDataOriginEnum.PM_PLATFORM) return Squares2X2Icon
  return CpuChipIcon
}

interface Props {
  process: ProcessAnalysisConfig
}

const TrackedProcessCardLead = ({ process }: Props) => {
  const Icon = leadIcon(process.process_data_origin)

  return (
    <div className='flex min-w-0 flex-1 items-center gap-3'>
      <div className='flex size-11 shrink-0 items-center justify-center rounded-lg bg-primary-600 shadow-sm ring-2 ring-white transition group-hover:bg-primary-700'>
        <Icon className='size-5 text-white' />
      </div>
      <div className='min-w-0 flex-1 py-0.5'>
        <Text className='min-w-0 break-words leading-snug sm:line-clamp-2' size='m' weight={600}>
          {process.name}
        </Text>
        <span className='mt-1 inline-flex'>
          <ProcessOriginBadge origin={process.process_data_origin} />
        </span>
      </div>
    </div>
  )
}

export default TrackedProcessCardLead

